// extracted by mini-css-extract-plugin
module.exports = {"publicacoes":"styles_publicacoes__1tlQf","box":"styles_box__31vdk","boxDocs":"styles_boxDocs__3YeHT"};